import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import styles from "./style.module.css";
import { ElevatorButton } from "@/domains/estate/components/elevator/components/ElevatorButton";
import { ElevatorBusinessFloorDisplay } from "@/domains/estate/components/elevator/components/business/ElevatorBusinessFloorDisplay";

export function ElevatorBusiness({
  floors,
  targetFloor,
  currentFloor,
  onTargetFloorChange,
  size,
}: {
  floors: number[];
  targetFloor: number;
  currentFloor: number;
  onTargetFloorChange: (floor: number) => void;
  size: "sm" | "md" | "lg";
}) {
  const variant = EstateComplexLevel.Business;
  const isIdle = targetFloor === null || currentFloor === targetFloor;
  const direction = currentFloor > targetFloor ? "down" : "up";

  if (size === "lg") return null;

  return (
    <div className={styles.container}>
      <div className={styles.inner} />

      <ElevatorBusinessFloorDisplay value={currentFloor} direction={isIdle ? "idle" : direction} />

      <div className="flex flex-wrap justify-center w-full px-[30px] gap-[6px] items-center">
        {floors.map((floor) => {
          return (
            <ElevatorButton
              key={floor}
              variant={variant}
              isActive={floor === targetFloor}
              onClick={() => onTargetFloorChange(floor)}
              size={size === "sm" ? "lg" : "md"}
            >
              <span className="tracking-tighter">{floor}</span>
            </ElevatorButton>
          );
        })}
      </div>
    </div>
  );
}
